import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import lang from '../../../../../lib/language';
import { RatiosPeriodType } from '../../../../../lib/models/fundamental/types';

import iconClose from '../../../../../assets/img/close-line.svg';
import iconExpandUp from '../../../../../assets/img/icon_expan_down_ratios.svg';
import { ClickableDiv, ClickableImage } from '../../../../../components';

import BaseTimeOptionsModal from './BaseTimeOptionsModal';

import styles from './TimeOptionsModal.module.scss';

type TimeOptionsModalProps = {
  options: string[];
  currentOption: string;
  onTimeChange: (index: number) => void;
  isDisabled: boolean;
  currentPeriod: string;
};

const TimeOptionsModal: React.FC<TimeOptionsModalProps> = ({
  options,
  currentOption,
  onTimeChange,
  isDisabled = false,
  currentPeriod,
}) => {
  const [isFilterModal, setFilterModal] = useState<boolean>(false);
  const [value, setValue] = useState<string>(currentOption);

  useEffect(() => {
    setValue(currentOption);
  }, [currentOption]);

  const handleOptionClick = (index: number, option: string) => {
    onTimeChange(index);
    setValue(option);
  };

  const capitalizeFirstLetter = (text: string | undefined) => {
    if (!text) return '';
    return text !== RatiosPeriodType.TTM ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : text;
  };

  const getTitle = () => {
    if (currentPeriod === RatiosPeriodType.QUARTERLY) {
      return lang.ratiosModalSelectQuarter();
    }
    if (currentPeriod === RatiosPeriodType.ANNUAL) {
      return lang.ratiosModalSelectYear();
    }

    return lang.ratiosModalSelectPeriod();
  };

  return (
    <>
      {currentPeriod !== RatiosPeriodType.TTM && (
        <ClickableDiv
          disabled={isDisabled}
          onClick={() => {
            if (!isDisabled) {
              setFilterModal(true);
            }
          }}
        >
          <div className={styles.wrapper}>
            <div className={styles.title}>
              <div
                className={classNames(
                  styles.titleText,
                  isDisabled ? styles.titleTextDisabled : styles.titleTextEnabled,
                )}
              >
                {isDisabled ? lang.commonNA() : capitalizeFirstLetter(currentOption)}
                <img
                  className={isDisabled ? styles.iconDisabled : styles.icon}
                  src={iconExpandUp}
                  alt="icon filter"
                />
              </div>
            </div>
          </div>
        </ClickableDiv>
      )}
      <BaseTimeOptionsModal
        customStyle={{
          paddingBottom: 0,
          margin: 0,
          width: window.innerWidth,
          position: 'fixed',
          alignSelf: 'flex-end',
          overflowY: 'auto',
          marginTop: window.innerHeight / 5.9,
        }}
        className={styles.filterModalWrapper}
        isOpen={isFilterModal}
        toggle={() => setFilterModal(false)}
      >
        <div className={styles.rangeButtonDescription}>
          <div>{getTitle()}</div>
          <div>
            <ClickableImage
              onClick={() => setFilterModal(false)}
              src={iconClose}
              alt="icon close"
              className={styles.closeIcon}
            />
          </div>
        </div>
        <div className={styles.rangeButtonWrapper}>
          {options.map((option, index) => (
            <ClickableDiv
              key={option}
              onClick={() => handleOptionClick(index, option)}
              className={styles.rangeButton}
            >
              <span
                className={
                  option === currentOption
                    ? styles.rangeButtonTextActive
                    : styles.rangeButtonText
                }
              >
                {option}
              </span>
            </ClickableDiv>
          ))}
        </div>
      </BaseTimeOptionsModal>
    </>
  );
};

export default TimeOptionsModal;
